import { render, staticRenderFns } from "./ThirdLogin.vue?vue&type=template&id=3b138cee&scoped=true&"
import script from "./ThirdLogin.vue?vue&type=script&lang=js&"
export * from "./ThirdLogin.vue?vue&type=script&lang=js&"
import style0 from "./ThirdLogin.vue?vue&type=style&index=0&id=3b138cee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b138cee",
  null
  
)

export default component.exports